import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

interface CategoryData {
  category: string;
  usage_count: number;
}

interface UseCategoriesOptions {
  accountType?: 'general' | 'reserve';
  transactionType?: 'income' | 'expense';
}

export const useCategories = (options: UseCategoriesOptions = {}) => {
  const { organization } = useAuth();
  const [categories, setCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!organization?.id) {
      setCategories([]);
      return;
    }

    const fetchCategories = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data, error: fetchError } = await supabase
          .rpc('get_unique_categories', {
            p_organization_id: organization.id,
            p_account_type: options.accountType || null,
            p_transaction_type: options.transactionType || null
          });

        if (fetchError) throw fetchError;

        // カテゴリ名のみの配列に変換
        const categoryNames = (data as CategoryData[])?.map(item => item.category) || [];
        setCategories(categoryNames);
      } catch (err) {
        console.error('カテゴリの取得に失敗しました:', err);
        setError('カテゴリの取得に失敗しました');
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [organization?.id, options.accountType, options.transactionType]);

  return {
    categories,
    loading,
    error,
    refetch: () => {
      // 強制的に再取得するためのトリガー
      const currentAccountType = options.accountType;
      const currentTransactionType = options.transactionType;
      return { accountType: currentAccountType, transactionType: currentTransactionType };
    }
  };
};